import { rest } from 'msw'

interface IFinanceSettings {
  budgetOvertureToggle: boolean
}

const defaultFinanceSettings: IFinanceSettings = {
  budgetOvertureToggle: false,
}

export const mockGetFinanceSettings = (
  settings: Partial<IFinanceSettings> = {}
) => {
  return rest.get(`/api/v3/settings/company/finance/`, (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json({
        data: {
          ...defaultFinanceSettings,
          ...settings,
        },
      })
    )
  })
}
